// extracted by mini-css-extract-plugin
export default {"countTag":"countTag__vTCbsZ"};